module.exports = function (fox) {
    'use strict';

    require('./stylus/_index.styl');
    require('./images/promo-iframe-comix.jpg');
    require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);

    var _script = {
        generate: function(mode, slider) {
            var modeString = `mode: \'${mode}\', // available values: 'centrobill' or 'prejoin',`;
            var type = 'tour';

            if (mode === 'own-billing') {
                modeString = `serverEndpoint: 'fake',`;
                type = 'member';
            }

            return `<script>
    (function (w, d, t, u, a, m) {
    a = d.createElement(t);
    m = d.getElementsByTagName(t)[0];
    a.async = 1;
    a.onload = function () {
        w.UMModels.init({
        container: '#root', // css selector or dom node
        apiKey: 'p4mt94k3hqabv38d9cks93h8902djsiw', // affiliate api key
        ${modeString}
        showHeaderSlides: ${slider} // show header slider, default value: true
        });
    }
    a.src = u;
    m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://ec-st.centrofiles.com/mcst/ummodels/0.2.1/js/ummodels.${type}.js');
</script>`;
        }
    }

    var VERSION = '0.2.6';

    fox.registerWidget('Promo_Iframe', {
        configure: function () {
            this.registerOptions('', {
                autoRender: true,
                template: 'promo_iframe_settings',
                container: '.iframe-preview-wrapper',
                handleDom: {
                    change: {
                        target: 'input[type="checkbox"], input[type="radio"]',
                        event: 'change',
                        callback: '_change'
                    },
                    paste: {
                        target: '.paste',
                        callback: 'paste'
                    }
                }
            });

            this.callParent('configure', arguments);
        },

        init: function() {
            this.callParent('init', arguments);
        },

        running: function() {
            this.start();
            
            this.bindTemplateVariables(this._bindData, ['script', 'previewUrl']);

        },

        activate: function() {
            this.start();

            this.callParent('activate', arguments);
        },

        start: function() {
            this._scriptParams = {mode: 'centrobill', slider: true};
            this.buildScript();

            this._bindData = {
                script: this._script,
                previewUrl: this.generatePreviewUrl(true)
            };
            
            this.bindTemplateVariables(this._bindData, ['script', 'previewUrl']);
        },

        addedToDom: function() {
            this.clipboard = new ClipboardJS('.copy-to-cp', {
                text: function(trigger) {
                    return this._script;
                }.bind(this)
            });
 
            this.clipboard.on('success', function(e) {
                this.switchState('copied');
                //e.clearSelection();
            }.bind(this));

            this.pasteBlock = this.dom1('#paste-block');
            this.pasteBlock.value = this._script;

            $(this.element).tooltip({
                position: {my: 'left-20% bottom-30', at: 'left bottom', collision: 'flipfit'},
                tooltipClass: 'gui-tooltip-type-1 bottom',
                items: '.mc-radiobutton.row',
                content: function () {
                    return $(this).find('.tt-content').html();
                }
            });
        },

        _change: function(elm) {
            var name = elm.name;
            var val = elm.value;

            if (name === 'slider') {
                val = elm.checked;
            }

            this._scriptParams[name] = val;
            this.buildScript();
            this._bindData.script = this._script;

            this.switchState();
        },

        buildScript: function() {
            this._script = this.getScript(this._scriptParams.mode, this._scriptParams.slider);
        },

        getScript: function(mode, slider) {
            return _script.generate(mode, slider);
        },

        paste: function() {
            this.pasteBlock.value = this.clipboard.text();

            this.showPreview();
            this.switchState('paste');
        },

        switchState: function(state) {
            var srcBlock = this.dom1('.copy-to-cp');
            var targetBlock = this.dom1('.paste');

            if (state === 'copied') {
                fox.dom.addClass('btn-major', srcBlock);

                srcBlock.innerHTML = 'COPIED';

                fox.dom.addClass('btn-primary', targetBlock);
                fox.dom.removeClass('btn-grey', targetBlock);
                fox.dom.removeClass('btn-major', targetBlock);

                return;
            }

            if (state === 'paste') {
                fox.dom.addClass('btn-major', targetBlock);
                fox.dom.removeClass('btn-grey', targetBlock);

                return;
            }

            srcBlock.innerHTML = 'COPY';
            fox.dom.removeClass('btn-major', srcBlock);

            fox.dom.removeClass('btn-primary', targetBlock);
            fox.dom.removeClass('btn-major', targetBlock);
            fox.dom.addClass('btn-grey', targetBlock);
        },

        generatePreviewUrl: function(empty) {
            var params = function() {
                var str = `mode=${this._scriptParams.mode}&slider=${Number(this._scriptParams.slider)}&version=${VERSION}`;

                if (empty === true) {
                    str = '';
                }

                return str;
            }.bind(this)();
            return `https://ec-st.centrofiles.com/mcst/mcp-iframe/i3.html?${params}#/`;
        },

        showPreview: function() {
            this._bindData.previewUrl = this.generatePreviewUrl();
        }
    });

};


// WEBPACK FOOTER //
// ./components/iframe/index.es.js